import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { HeroSection } from "@/components/HeroSection";
import { StorySection } from "@/components/StorySection";
import { PhilosophySection } from "@/components/PhilosophySection";
import { ExpertiseSection } from "@/components/ExpertiseSection";
import { ReferencesSection } from "@/components/ReferencesSection";
import { ContactSection } from "@/components/ContactSection";
import { SEOStructuredData } from "@/components/SEOStructuredData";
import { SEOPageMeta } from "@/components/SEOPageMeta";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToExpertise) {
      // Small delay to ensure the page has loaded
      setTimeout(() => {
        const expertiseSection = document.getElementById('expertise');
        if (expertiseSection) {
          expertiseSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      // Clear the state
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return (
    <div className="min-h-screen">
      <SEOPageMeta 
        title="Executive Search für Hotellerie und Gastronomie"
        description="Scholz Interim - Headhunter und Personalvermittler für Führungskräfte in Hotellerie, Gastronomie und Tourismus. Seit 2002 über 900 erfolgreiche Vermittlungen mit strategischer Expertise."
        path="/"
        keywords={["Headhunter", "Executive Search", "Hotellerie", "Gastronomie", "Personalvermittlung", "Führungskräfte", "Interim Management"]}
      />
      <SEOStructuredData />
      <Header />
      <main>
        <HeroSection />
        <StorySection />
        <ExpertiseSection />
        <ReferencesSection />
        <PhilosophySection />
        <ContactSection />
      </main>
      <Footer />
      
    </div>
  );
};

export default Index;